module.exports = __webpack_public_path__ + "static/media/MFA-Background-005.919cdee1.png";